import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
import 'swiper/swiper-bundle.min.css';

import { BitrixVue } from 'ui.vue';

BitrixVue.component('Swiper', {
	data() {
		return {
			activeIndex: 0,
			selectedBreakpoints: 0,
			defaultBreakpoints: {
				2: {
					1100: {
						slidesPerView: 2,
						spaceBetween: 20,
					},
					900: {
						slidesPerView: 2,
					},
					750: {
						slidesPerView: 3,
					},
					600: {
						slidesPerView: 2,
						spaceBetween: 15,
					},
				},
				3: {
					1100: {
						spaceBetween: 20,
						slidesPerView: 3,
					},
					900: {
						slidesPerView: 2,
					},
					600: {
						slidesPerView: 3,
						spaceBetween: 15,
					},
					500: {
						slidesPerView: 2,
					},
				},
				4: {
					1100: {
						slidesPerView: 4,
						spaceBetween: 20,
					},
					900: {
						slidesPerView: 3,
					},
					750: {
						slidesPerView: 4,
					},
					600: {
						slidesPerView: 3,
						spaceBetween: 15,
					},
					500: {
						slidesPerView: 3,
					},
				},
				6: {
					1100: {
						slidesPerView: 6,
						spaceBetween: 20,
					},
					900: {
						slidesPerView: 4,
					},
					750: {
						slidesPerView: 6,
					},
					600: {
						slidesPerView: 5,
						spaceBetween: 15,
					},
					500: {
						slidesPerView: 4,
					},
				},
			},
		};
	},
	props: [
		'state',
		'loopSlides',
		'basicSlidesPerView',
		'basicSpaceBetween',
		'breakpointsForSlides',
	],
	mounted() {
		if (this.breakpointsForSlides) {
			typeof this.breakpointsForSlides === 'number'
				? (this.selectedBreakpoints =
						this.defaultBreakpoints[this.breakpointsForSlides])
				: (this.selectedBreakpoints = this.breakpointsForSlides);
		} else {
			this.selectedBreakpoints = {};
		}

		new Swiper(this.$refs.swiper, {
			modules: [Navigation, Pagination, Autoplay],
			loop: this.loopSlides ? this.loopSlides : false,
			speed: 400,
			slidesPerView: this.basicSlidesPerView ? this.basicSlidesPerView : 1,
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
			spaceBetween: this.basicSpaceBetween ? this.basicSpaceBetween : 10,
			breakpoints: this.selectedBreakpoints,
			navigation: {
				nextEl: '.slider-button-next',
				prevEl: '.slider-button-prev',
			},
			on: {
				slideChange: (swiper) => {
					this.activeIndex = swiper.realIndex;
				},
			},
		});
	},
	updated(){
		this.$refs.swiper.swiper.update()
		this.$refs.swiper.swiper.updateSlides()
		this.$refs.swiper.swiper.updateProgress()
		this.$refs.swiper.swiper.updateSize()
		this.$refs.swiper.swiper.updateSlidesClasses()
	},
	template: `
	<div ref="swiper" class="config-slider__wrap">
			<div class="swiper-wrapper">
					<slot></slot>
			</div>
			<div class="slider-button-prev"></div>
			<div class="slider-button-next"></div>
	</div>
`,
});
